import React from 'react'
import View from './view'

const CookiePolicy = ({ ...props }) => {
  return <View {...props} />
}

export default CookiePolicy
